import {
    LIST_EVENTS
} from './EventActionTypes';
import { switchMap, map, catchError } from 'rxjs/operators';
import { combineEpics } from 'redux-observable';
import config from 'react-global-configuration';
import {
    errorHandlingWithLogoutCheck,
    getJsonWithAuth
} from "../../../components/AjaxHelpers";
import {eventActions, eventSelectors} from "./index";

export const eventEpics = combineEpics(

    // Events of type LIST_EVENTS
    (action$, state$) => action$.ofType(LIST_EVENTS).pipe(
        switchMap(action => {
              let filter = eventSelectors.eventListFilter(state$.value);
              let queryParams = new URLSearchParams({
                    from: filter.from!==""?filter.from+'T00:00:00.000Z':"",
                    before: filter.before!==""?filter.before+'T00:00:00.000Z':"",
                    receivingOrganizationId: filter.careUnitOrganizationId,
                    sendingOrganizationId: filter.opticianOrganizationId,
                    eventTypes: filter.eventType || "",
                    page: action.page != null ? action.page : 0,
                    size: 25,
              });

              return getJsonWithAuth({
                url: config.get('apiBaseUrl') + '/events/v1?' + queryParams.toString(),
                state: state$.value
              }).pipe(
                  map(payload => eventActions.listEventsSucceeded(payload)),
                  catchError(response => errorHandlingWithLogoutCheck(response,
                      [eventActions.listEventsFailed(response)],
                      "Något gick fel när lista av händelser skulle hämtas."))
              )
            }
        )
    ),

);